const textUnderlineOffset = {
  name: "text-underline-offset",
  path: "/text-underline-offset",
  title: "text-underline-offset",
  description: "Utilities for controlling the offset of underlines from their original position.",
  value: {
    "text-underline-offset": {
      "underline-offset-auto": "auto",
      "underline-offset-<number>": "<number>px",
      "-underline-offset-<number>": "calc(<number>px * -1)",
      "underline-offset-[<value>]": "<value>"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="underline underline-offset-auto">This underline uses auto offset.</p>
<p class="underline underline-offset-2">This underline is offset by 2px.</p>
<p class="underline underline-offset-4">This underline is offset by 4px.</p>
<p class="underline -underline-offset-2">This underline is offset by -2px.</p>
<p class="underline underline-offset-[0.5em]">This underline is offset by 0.5em.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">underline-offset-auto</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">underline-offset-2</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">-underline-offset-2</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">underline-offset-[0.5em]</code> to control the underline offset.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">underline-offset-auto</small>
          <p class="underline underline-offset-auto text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">underline-offset-2</small>
          <p class="underline underline-offset-2 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">underline-offset-4</small>
          <p class="underline underline-offset-4 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">-underline-offset-2</small>
          <p class="underline -underline-offset-2 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">underline-offset-[0.5em]</small>
          <p class="underline underline-offset-[0.5em] text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
};

export default textUnderlineOffset;
<div className="underline underline-offset-auto underline-offset-2 underline-offset-4 -underline-offset-2 underline-offset-[0.5em] sr-only"></div>